import {z} from 'zod'

export const GetAssignedSegmentsRequestSchema = z.object({
  country: z.string(),
  query: z.string().optional(),
})

export const GetAssignedSegmentsResponseSchema = z.object({
  segments: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    })
  ),
})

export type GetAssignedSegmentsRequest = z.infer<typeof GetAssignedSegmentsRequestSchema>
export type GetAssignedSegmentsResponse = z.infer<typeof GetAssignedSegmentsResponseSchema>
